var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),schema = locals_.schema,value = locals_.value,record = locals_.record,time = locals_.time;
var jade_indent = [];
buf.push("\n<div class=\"row\">\n  <div class=\"col-lg-12\">\n    <table class=\"table\">\n      <tbody></tbody>");
// iterate schema.properties
;(function(){
  var $$obj = schema.properties;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var property = $$obj[name];

value = record.properties[name]
buf.push("\n      <tr>\n        <td class=\"field-name\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</td>");
if (property.type == 'boolean')
{
buf.push("\n        <td class=\"field-value\">\n          <div" + (jade.cls(['label','label-default',"" + (value ? 'label-success' : '') + ""], [null,null,true])) + ">YES</div>\n          <div class=\"space\"></div>\n          <div" + (jade.cls(['label','label-default',"" + (value ? '' : 'label-danger') + ""], [null,null,true])) + ">NO</div>\n        </td>");
}
else if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("\n        <td class=\"field-value\">\n          <pre>");
if (time)
{
buf.push("" + (jade.escape((jade_interp = time) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("<i>EMPTY</i>");
}
buf.push("</pre>\n        </td>");
}
else
{
buf.push("\n        <td class=\"field-value\">\n          <pre>");
if (value)
{
buf.push("" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("<i>EMPTY</i>");
}
buf.push("</pre>\n        </td>");
}
buf.push("\n      </tr>");
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var property = $$obj[name];

value = record.properties[name]
buf.push("\n      <tr>\n        <td class=\"field-name\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</td>");
if (property.type == 'boolean')
{
buf.push("\n        <td class=\"field-value\">\n          <div" + (jade.cls(['label','label-default',"" + (value ? 'label-success' : '') + ""], [null,null,true])) + ">YES</div>\n          <div class=\"space\"></div>\n          <div" + (jade.cls(['label','label-default',"" + (value ? '' : 'label-danger') + ""], [null,null,true])) + ">NO</div>\n        </td>");
}
else if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("\n        <td class=\"field-value\">\n          <pre>");
if (time)
{
buf.push("" + (jade.escape((jade_interp = time) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("<i>EMPTY</i>");
}
buf.push("</pre>\n        </td>");
}
else
{
buf.push("\n        <td class=\"field-value\">\n          <pre>");
if (value)
{
buf.push("" + (jade.escape((jade_interp = value) == null ? '' : jade_interp)) + "");
}
else
{
buf.push("<i>EMPTY</i>");
}
buf.push("</pre>\n        </td>");
}
buf.push("\n      </tr>");
    }

  }
}).call(this);

buf.push("\n    </table>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}